<template>
    <div class="main">

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Relatório de" key="tipo">
                                <el-select v-model="filtro.tipo" @change="changeTipo()">
                                    <el-option label="NOTAS" value="nota"></el-option>
                                    <el-option label="FALTAS" value="falta"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Visão" key="visao">
                                <el-select v-model="filtro.visao" @change="filtro.periodo = ''; filtro.disciplina = ''">
                                    <el-option label="POR PERÍODO (um período, todas as disciplinas)" value="periodo"></el-option>
                                    <el-option label="POR DISCIPLINA (uma disciplina, todos os períodos)" value="disciplina"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                <el-select @change="getTurmas()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9 || $store.state.user.tipo == 12">
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Ano letivo" key="periodo_letivo">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" clearable>
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Turma" key="turma">
                                <el-select v-model="filtro.turma_id" @change="changeTurma()" clearable filterable>
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="turma in grupo" :key="turma.id" :label="`${turma.curso.nome} ${turma.nome}`" :value="turma.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="filtro.visao == 'periodo'">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Período do Diário" key="periodo">
                                <el-select v-model="filtro.periodo" clearable>
                                    <el-option v-for="(periodo, i) in turmaSelecionada.periodos_diario" :key="i" :label="periodo" :value="i + 1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="filtro.visao == 'disciplina'">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Disciplina" key="disciplina">
                                <el-select v-model="filtro.disciplina" clearable filterable>
                                    <el-option v-if="filtro.tipo == 'falta' && turmaSelecionada.id" label="FREQUÊNCIA GERAL" value="f1"></el-option>
                                    <el-option v-for="disciplina in turmaSelecionada.disciplinas" :key="disciplina.id" :label="disciplina.nome" :value="String(disciplina.id)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="gerarPdf()" :loading="loadingButtonPdf" type="primary">GERAR RELATÓRIO</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-form>

    </div>
</template>
<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonPdf: false,
        filtro: {
            tipo: 'nota',
            visao: 'periodo',
            instituicao_id: '',
            periodo_letivo_id: '',
            turma_id: '',
            periodo: '',
            disciplina: ''
        },
        turmas: [],
        turmaSelecionada: {}
    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9 || this.$store.state.user.tipo == 12) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.getTurmas();
    },
    methods: {

        changeTipo(){
            this.filtro.disciplina = '';
        },

        getTurmas(){

            this.filtro.turma_id = '';
            this.turmaSelecionada = {};

            if(!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id){
                this.turmas = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;

                // Professor vê só as turmas em que leciona; os demais perfis, todas as da instituição.
                if(this.$store.state.user.tipo == 2){
                    this.filtrarTurmasDoProfessor();
                }

            }).catch((error) => { this.$store.commit('throwException', error); });
        },

        filtrarTurmasDoProfessor(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/init/${this.filtro.instituicao_id}?periodo_letivo_id=${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                const minhas = ((response.data && response.data.turmas) || []).map(t => t.id);
                const filtradas = {};

                for(let grupo in this.turmas){
                    const lista = this.turmas[grupo].filter(t => minhas.includes(t.id));
                    if(lista.length){ filtradas[grupo] = lista; }
                }

                this.turmas = filtradas;

            }).catch((error) => { this.$store.commit('throwException', error); });
        },

        changeTurma(){

            this.filtro.periodo = '';
            this.filtro.disciplina = '';
            this.turmaSelecionada = {};

            for(let grupo in this.turmas){
                for(let t of this.turmas[grupo]){
                    if(t.id == this.filtro.turma_id){
                        this.turmaSelecionada = t;
                        return;
                    }
                }
            }
        },

        gerarPdf(){

            if(!this.filtro.turma_id){
                window.eventBus.$emit('alert', {msg: 'Selecione a turma.', type: 'warning'});
                return;
            }
            if(this.filtro.visao == 'periodo' && !this.filtro.periodo){
                window.eventBus.$emit('alert', {msg: 'Selecione o período do diário.', type: 'warning'});
                return;
            }
            if(this.filtro.visao == 'disciplina' && !this.filtro.disciplina){
                window.eventBus.$emit('alert', {msg: 'Selecione a disciplina.', type: 'warning'});
                return;
            }

            this.loadingButtonPdf = true;

            let payload = {
                tipo: this.filtro.tipo,
                visao: this.filtro.visao,
                turma_id: this.filtro.turma_id,
                periodo: this.filtro.periodo,
                disciplina: this.filtro.disciplina
            };

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioPeriodo`, payload, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonPdf = false;

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const novaAba = window.open(url, '_blank');
                if(!novaAba){ window.location.href = url; }

            }).catch((error) => { this.loadingButtonPdf = false; window.eventBus.$emit('alert', {msg: 'Erro ao gerar o relatório.', type: 'warning'}); this.$store.commit('throwException', error); });
        }
    }
}
</script>
